'use client';
import * as React from "react";
import { useTeachingPopoverCarouselCard_unstable } from "./useTeachingPopoverCarouselCard.js";
import { renderTeachingPopoverCarouselCard_unstable } from "./renderTeachingPopoverCarouselCard.js";
import { useTeachingPopoverCarouselCardStyles_unstable } from "./useTeachingPopoverCarouselCardStyles.styles.js";
import { useCustomStyleHook_unstable } from "@fluentui/react-shared-contexts";
/**
 * Define a styled TeachingPopoverCarouselCard, using the `useTeachingPopoverCarouselCard_unstable` and `useTeachingPopoverCarouselCardStyles_unstable`
 * hooks.
 *
 * TeachingPopoverCarouselCard is the definition of a single page view within the carousel, they are shown one at a time and can be navigated through sequentially.
 */ export const TeachingPopoverCarouselCard = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useTeachingPopoverCarouselCard_unstable(props, ref);
    useTeachingPopoverCarouselCardStyles_unstable(state);
    useCustomStyleHook_unstable('useTeachingPopoverCarouselCardStyles_unstable')(state);
    return renderTeachingPopoverCarouselCard_unstable(state);
});
TeachingPopoverCarouselCard.displayName = 'TeachingPopoverCarouselCard';
